$(document).ready(function(){
$('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');


  $('h1, h2, h3, h4, h5, h6').filter(function() {
    return $(this).text().replace(/\s+/g, '') === '' && 
           $(this).children().length === 0;
  }).remove();

});


// Social and External link warning Fixed
$(document).ready(function() {
  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = " Redirecting to a third-party website,opens in a new tab.";

  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return;

    
    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find('img').attr('alt');
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    
    const currentAriaLabel = $link.attr('aria-label');
    const newLabel = currentAriaLabel 
      ? `${currentAriaLabel}${warningText}` 
      : `${linkText}${warningText}`;

    
    $link.attr({
      'aria-label': newLabel,
      'title': newLabel,
      'target': '_blank',
      'rel': 'noopener noreferrer nofollow'
    });

    $link.addClass('external-link');
  });
});

// Email Label to all Email Address
$(document).ready(function() {
  $('a[href^="mailto:"]').each(function() {
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
   
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Phone Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
}); 

// Homepage tabs
$(document).ready(function() {
  $('banner-with-tabs').each(function () {

    const $component = $(this);
    const $tabs = $component.find('[role="tab"]');
    const $panels = $component.find('[role="tabpanel"]');

    function updateTabs(selectedIndex) {

      $tabs.each(function (index) {
        const isSelected = index === selectedIndex;
        $(this).attr('aria-selected', isSelected);
      });

      $panels.each(function (index) {
        const isActive = index === selectedIndex;

        $(this)
          .attr('aria-hidden', !isActive)
          .attr('tabindex', isActive ? '0' : '-1');
      });

    }

    // Initial state
    const initialIndex = parseInt($component.data('selected')) || 0;
    updateTabs(initialIndex);

    // Click event
    $tabs.on('click', function () {
      const index = $(this).data('index');
      updateTabs(index);
    });

  });
}); 

// product gallery slider accessibility cleanup (removing role/aria-label that Swiper adds which causes issues with screen readers)
$(document).ready(function() {
    const stripA11y = () => {
        $('.product__media-item, .product__thumbs-item').removeAttr('role aria-label');
    };

    // Run on page load
    stripA11y();

    // Run after a tiny delay to ensure Swiper has finished its internal init
    setTimeout(stripA11y, 500);

    // If your theme triggers a variant change event, hook into it
    $(document).on('variant:change', function() {
        setTimeout(stripA11y, 100);
    });
});

// Thumbnail Gallery Accessibility Fixes
$(document).ready(function() {
    function updateThumbnailA11y() {
        const $thumbs = $('.product__thumbs-item');

        $thumbs.each(function() {
            const isVisible = $(this).hasClass('swiper-slide-visible');

            if (isVisible) {
                $(this).attr('aria-hidden', 'false');
                $(this).removeAttr('tabindex'); // Make focusable
            } else {
                $(this).attr('aria-hidden', 'true');
                $(this).attr('tabindex', '-1'); // Remove from tab order
            }
        });
    }

    updateThumbnailA11y();

    const observer = new MutationObserver(updateThumbnailA11y);
    const galleryElement = document.querySelector('.product__media-gallery-thumbails');
    
    if (galleryElement) {
        observer.observe(galleryElement, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
        });
    }
});

// Testimonial Slider
/**
 * Accessibility Fix for Testimonials Slider
 * 1. Removes role="group" and aria-label from all slides.
 * 2. Sets aria-hidden="true" on all slides by default.
 * 3. Sets aria-hidden="false" specifically for the active/visible slide.
 */
function patchTestimonialAccessibility() {
  const container = document.querySelector('testimonials-component');
  if (!container) return;

  const updateSlides = () => {
    const slides = container.querySelectorAll('.swiper-slide');
    
    slides.forEach((slide) => {
      // Clean up unnecessary attributes
      slide.removeAttribute('role');
      slide.removeAttribute('aria-label');

      // Check visibility based on the active class
      if (slide.classList.contains('swiper-slide-active')) {
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  };

  // Run on initial load
  updateSlides();

  // Use MutationObserver to watch for class changes (slide transitions)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updateSlides();
      }
    });
  });

  // Start observing each slide for class changes
  const allSlides = container.querySelectorAll('.swiper-slide');
  allSlides.forEach(slide => {
    observer.observe(slide, { attributes: true });
  });
}

// Initialize on DOMContentLoaded or Shopify Section Load
document.addEventListener('DOMContentLoaded', patchTestimonialAccessibility);

// Ensure it works if the section is re-rendered in the Theme Editor
document.addEventListener('shopify:section:load', patchTestimonialAccessibility);

//Mobile Menu FOcus
$(document).ready(function() {
  $('.menu-drawer-button').on('click', function() {
    const $menuDrawer = $('#MenuDrawer');
    
    setTimeout(function() {
      //Focus the first actual link in the menu (Better for UX)
      $menuDrawer.find('summary, a, button').first().focus();
    }, 100);
  });
});

$(document).ready(function() {
  $('.slideshow-with-product__buttons .btn').attr('aria-label', 'SHOP NOW New Mobi Pocket Patch!');
});

$(document).ready(function() {
    // 1. Forward Focus: Parent Menu to Submenu First Element
    $('summary.menu-drawer__item-link').on('click', function(e) {
        const $details = $(this).parent('details');
        
        // Use a timeout to allow the menu to animate or open before shifting focus
        setTimeout(() => {
            if ($details.prop('open') || $(this).attr('aria-expanded') === 'true') {
                // Target the back button or the first link in the submenu
                const $firstElement = $details.find('.menu-drawer__submenu').find('button, a').first();
                $firstElement.focus();
            }
        }, 100); 
    });

    // 2. Backward Focus: Back Button to Parent Menu Item
    $('.menu-drawer__item-back-link').on('click', function(e) {
        e.preventDefault();
        
        const $parentDetails = $(this).closest('details[is="menu-drawer-details"]');
        const $parentSummary = $parentDetails.find('summary').first();
        
        $parentSummary.focus();
        
    });
});

$(document).ready(function () {
  $('.button-list__item').on('click', function (e) {
    e.preventDefault();

    let index = $(this).find('.button-item').data('index');
    let targetSection;

    if (index === 0) {
      targetSection = $('.skingrip1');
    } else if (index === 1) {
      targetSection = $('.max2');
    } else if (index === 2) {
      targetSection = $('.tav-section-template--21734584123636__tabs_accessible_video_BmE38V');
    } else if (index === 3) {
      targetSection = $('.tav-section-template--21734584123636__tabs_accessible_video_NE87EA');
    }

    if (targetSection.length) {
      // scroll
      $('html, body').animate({
        scrollTop: targetSection.offset().top
      }, 500);

      // focus (accessible)
      targetSection.attr('tabindex', '-1').focus();
    }
  });
  $('.facet-drawer-wrapper button').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  });
  $('.heading_level h1').each(function () {
    var attrs = '';
    $.each(this.attributes, function () {
      attrs += ' ' + this.name + '="' + this.value + '"';
    });
    $(this).replaceWith('<h2' + attrs + '>' + $(this).html() + '</h2>');
  });
  if ($('body').hasClass('page-template')) {
    if ($('h1').length === 0) {
      var pageTitle = $('[data-page-title]').text().trim()
                   || $('.page-title').text().trim()
                   || document.title.split('|')[0].trim();

      $('main').prepend(
        $('<h1>', {
          class: 'skip-link visually-hidden',
          text: pageTitle
        })
      );
    }
  }
  $('product-promotion-alert .product__promotion-alert-heading h6').attr('aria-level','2');
});